var isKind = require('./isKind');
    /**
     */
    var isArray = Array.isArray || function (val) {
        return isKind(val, 'Array');
    };
    module.exports = isArray;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isArray.js
// module id = 64
// module chunks = 0 1 2